import { type ComponentType, type ReactNode, Suspense } from 'react'
import { InvestmentsLoading } from 'investments/common/components/ui'
import { useFetchAccountDetails } from 'investments/common/hooks'
import BlackBird from 'shared/blackbird'

import { useDeusExMachina } from '~/domains/platform/infra/deus-ex-machina/hocs/with-deus-ex-machina'

import {
  redirectNotAvailable,
  redirectOnboarding
} from '../helpers/investments-journey-redirects'

function InvestmentsJourneyGuard({
  accountId,
  children
}: {
  accountId: string
  children: ReactNode
}) {
  const { data: accountDetailsData } = useFetchAccountDetails({ accountId })

  // TODO: validar se o fluxo de onboarding será removido permanentemente ou reativado
  // const { isFeatureFlagEnabled, isLoading: isExpLoading } = useExperiment(
  //   subjectId,
  //   'market_investments_flow',
  //   undefined,
  //   { suspense: true }
  // )

  if (!accountDetailsData) {
    return <InvestmentsLoading />
  }

  const pathname = BlackBird.getPathname()
  // TODO: validar se o fluxo de onboarding será removido permanentemente ou reativado
  /* const needsOnboarding =
    accountDetailsData.journey === 'needs_onboarding' && isFeatureFlagEnabled */

  const needsOnboarding = false

  if (redirectNotAvailable(accountDetailsData.journey, pathname)) {
    return <InvestmentsLoading />
  }

  if (redirectOnboarding(needsOnboarding, pathname)) {
    return <InvestmentsLoading />
  }

  return children
}

export function withInvestmentsGuard(
  WrappedComponent: ComponentType<any>
): ComponentType<any> {
  return function InvestmentsGuardedPage(props: any) {
    const { deusExMachina } = useDeusExMachina()
    const accountId = deusExMachina?.entity.paymentAccount.id
    const subjectId = deusExMachina?.subject?.id

    if (!accountId || !subjectId) {
      return <InvestmentsLoading />
    }

    return (
      <Suspense fallback={<InvestmentsLoading />}>
        <InvestmentsJourneyGuard accountId={accountId}>
          <WrappedComponent
            {...props}
            accountId={accountId}
            subjectId={subjectId}
          />
        </InvestmentsJourneyGuard>
      </Suspense>
    )
  }
}
